import { legacy_connect as connect } from 'react-redux';

import { AppState } from '../../../store/reducers/root';
import { getActiveDictionariesIds } from '../../../store/selectors/dictionary';

import ActiveDictionaries from './ActiveDictionaries';

const mapStateToProps = (state: AppState) => ({
  ids: getActiveDictionariesIds(state),
});

export default connect(mapStateToProps)(ActiveDictionaries);
